<template>
  <footer class="ai-footer-links">
    <nav class="ai-footer-links__nav">
      <a v-for="item in items" :key="item.key" :href="item.href" target="_blank">
        {{ item.title }}
      </a>
    </nav>
    <div v-if="runtimeConfig.copyright" class="ai-footer-links__copyright">
      {{ runtimeConfig.copyright }}
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { runtimeConfig } from '@/config/runtime';

const items = computed(() => (runtimeConfig.bottom_btns ?? []).filter(item => (
  item?.title?.trim()
)).map((item, index) => ({
  key: `bottom-button-${index}`,
  title: item.title.trim(),
  href: item.href.trim(),
})));
</script>

<style scoped lang="scss">
.ai-footer-links {
  color: #999;
  text-align: center;
}

.ai-footer-links__nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 18px;

  a {
    padding: 7px 18px;
    border: 1px solid rgba(0, 0, 0, .08);
    border-radius: 999px;
    color: inherit;
    text-decoration: none;

    &:hover { color: #333; }
  }
}

.ai-footer-links__copyright a {
  color: inherit;
  text-decoration: none;
}

@media (max-width: 600px) {
  .ai-footer-links__nav {
    gap: 6px;

    a {
      padding: 5px 10px;
      font-size: 12px;
    }
  }

  .ai-footer-links__copyright { font-size: 12px; }
}
</style>
